import type { i18n } from "i18next"

import { getWalkingTime } from "@bounce/store"
import type { Coordinates } from "@bounce/util"
import { coordinatesToDistanceInMeters, getWalkingTimeInMinutes } from "@bounce/util"

import type { FeaturedPoiData } from "./StoreSlider"
import type { CityStorageSpot, NearbyStorageSpot } from "../../../libs/bounce/stores/types"

type Store = NearbyStorageSpot | CityStorageSpot

export const MAX_STORE_SLIDER_CARD_POIS = 2

export const getStoreAnchor = (storeId: string) => `store-${storeId}`

export const getFeaturedPoiWithDistance = (poi: FeaturedPoiData, coordinates: Coordinates) => {
  return {
    ...poi,
    distance: coordinatesToDistanceInMeters(poi.coordinates, coordinates),
  }
}

export const getPoisWithWalkingTime = (store: Store, i18n: i18n, featuredPoi?: FeaturedPoiData) => {
  const featuredPoiWithDistance = featuredPoi ? getFeaturedPoiWithDistance(featuredPoi, store.coordinates) : null

  const allPois = [
    ...(featuredPoiWithDistance ? [featuredPoiWithDistance] : []),
    ...(store.pois?.filter(poi => poi.id !== featuredPoi?.id) ?? []),
  ]

  return allPois
    .map(poi => ({
      ...poi,
      walkingTime: getWalkingTime(poi.distance, i18n),
      walkingTimeInMinutes: getWalkingTimeInMinutes(poi.distance),
    }))
    .slice(0, MAX_STORE_SLIDER_CARD_POIS)
}
